import React, {useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';

import Breadscrumbs from "../components/Breadscrumbs";
import MarkdownRenderer from "./MarkdownRenderer";

const ServicePage = () => {
  const { slug } = useParams();
  const [service, setService] = useState("");

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_STRAPI_API_URL}/service-articles?filters[slug][$eq]=${slug}&populate=*`, {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_STRAPI_TOKEN}`,
      }
    }).then(res => {
      setService(res.data.data[0]);
    }).catch(err => console.error(err));
  }, [slug])

  return (
    <div>
      <Breadscrumbs
        title={service.title}
      />

    <div className="max-w-4xl mx-auto px-4 md:px-8 py-12">
        <MarkdownRenderer content={service.content}/>
    </div>

    </div>
  );
};

export default ServicePage;
